import { FC, useMemo } from 'react';
import { Wrapper, DeleteButton } from './styles';
import { ProjectAddButton } from 'shared/pages/projectEdit/ProjectAddButton';
import { useTranslation } from 'react-i18next';
import { BLanguageSelectionComponent } from 'core/components/BLanguageSelectionComponent';
import { SaveUserLang } from '../__ADDONS__/__LANG__/Utils/GetUserLang';
import { setAppLang } from '../__ADDONS__/__LANG__/Slice';
import { BilingualismItem } from 'shared/pages/projectEdit/styles';
import { FlexBox } from '@brg/ui';
import { AppTester } from 'supporting';
import { getDafesBilingualSwitcherKey } from 'shared/helpers/getDafesBilingualI18nKey';
import { normalizeProjectLangSwitcherCode } from 'shared/helpers/projectLangSwitcher';

type IProps = {
    isBilingual: boolean;
    isCompetitionEdit?: boolean;
    isProjectEditPage?: boolean;
    isBookEdit?: boolean;
    text?: string;
    onClick: () => void;
}

export const BilingualSwitcher: FC<IProps> = ({ isBilingual, text, onClick, isCompetitionEdit, isProjectEditPage, isBookEdit }) => {
    const { t, i18n } = useTranslation();
    const isNewDafesSegment = AppTester.isNewDafesSegment();

    const switcherLabelKey = useMemo(() => {
        if (!isNewDafesSegment) {
            return isBilingual ? 'bilingual_switcher.delete' : 'bilingual_switcher.add';
        }

        return getDafesBilingualSwitcherKey(isBilingual, i18n.language);
    }, [isBilingual, isNewDafesSegment, i18n.language]);

    const AddButton = useMemo(() => {
        if (!isBilingual) {
            return <ProjectAddButton
                text={text || t(switcherLabelKey)}
                isBookEdit={isBookEdit}
                isProjectEdit={isProjectEditPage}
                isCompetitionEdit={isCompetitionEdit}
                hideIcon={isCompetitionEdit || isProjectEditPage}
                onClick={onClick}
                reverse
            />
        }

        return <DeleteButton className='remove-lang-button' isCompetitionEdit={isCompetitionEdit} onClick={onClick}>{text || t(switcherLabelKey)}</DeleteButton>
    }, [isBilingual, onClick, t, isCompetitionEdit, isBookEdit, isProjectEditPage, switcherLabelKey, text])

    const LangSwitcher = useMemo(() => {
        if (!isBilingual) return null;

        return (
            <BLanguageSelectionComponent
                onLangSelect={(lang) => {
                    const normalizedLang = normalizeProjectLangSwitcherCode(lang);
                    SaveUserLang(normalizedLang);
                    setAppLang(normalizedLang);
                    i18n.changeLanguage(normalizedLang);
                }}
                key={'lang'}
                isProjectPage
                isCompetitionEdit={isCompetitionEdit}
            />
        )
    }, [i18n, isBilingual])

    return (
        <Wrapper>
            {AddButton}
            {isBilingual && i18n.language === 'en' && !isNewDafesSegment && <FlexBox direction='column' offsetTop={16}>
                <BilingualismItem>— AI does the translation</BilingualismItem>
                <BilingualismItem>— You can edit the AI translation</BilingualismItem>
                <BilingualismItem>— ​​Edited translation is considered author's translation</BilingualismItem>
                <BilingualismItem>— AI translation is updated automatically</BilingualismItem>
            </FlexBox>}
            {LangSwitcher}

        </Wrapper>
    )
}import { FC, useMemo } from 'react';
import { Wrapper, DeleteButton } from './styles';
import { ProjectAddButton } from 'shared/pages/projectEdit/ProjectAddButton';
import { useTranslation } from 'react-i18next';
import { BLanguageSelectionComponent } from 'core/components/BLanguageSelectionComponent';
import { SaveUserLang } from '../__ADDONS__/__LANG__/Utils/GetUserLang';
import { setAppLang } from '../__ADDONS__/__LANG__/Slice';
import { BilingualismItem } from 'shared/pages/projectEdit/styles';
import { FlexBox } from '@brg/ui';
import { AppTester } from 'supporting';
import { getDafesBilingualSwitcherKey } from 'shared/helpers/getDafesBilingualI18nKey';
import { normalizeProjectLangSwitcherCode } from 'shared/helpers/projectLangSwitcher';

type IProps = {
    isBilingual: boolean;
    isCompetitionEdit?: boolean;
    isProjectEditPage?: boolean;
    isBookEdit?: boolean;
    text?: string;
    onClick: () => void;
}

export const BilingualSwitcher: FC<IProps> = ({ isBilingual, text, onClick, isCompetitionEdit, isProjectEditPage, isBookEdit }) => {
    const { t, i18n } = useTranslation();
    const isNewDafesSegment = AppTester.isNewDafesSegment();

    const switcherLabelKey = useMemo(() => {
        if (!isNewDafesSegment) {
            return isBilingual ? 'bilingual_switcher.delete' : 'bilingual_switcher.add';
        }

        return getDafesBilingualSwitcherKey(isBilingual, i18n.language);
    }, [isBilingual, isNewDafesSegment, i18n.language]);

    const AddButton = useMemo(() => {
        if (!isBilingual) {
            return <ProjectAddButton
                text={text || t(switcherLabelKey)}
                isBookEdit={isBookEdit}
                isProjectEdit={isProjectEditPage}
                isCompetitionEdit={isCompetitionEdit}
                hideIcon={isCompetitionEdit || isProjectEditPage}
                onClick={onClick}
                reverse
            />
        }

        return <DeleteButton className='remove-lang-button' isCompetitionEdit={isCompetitionEdit} onClick={onClick}>{text || t(switcherLabelKey)}</DeleteButton>
    }, [isBilingual, onClick, t, isCompetitionEdit, isBookEdit, isProjectEditPage, switcherLabelKey, text])

    const LangSwitcher = useMemo(() => {
        if (!isBilingual) return null;

        return (
            <BLanguageSelectionComponent
                onLangSelect={(lang) => {
                    const normalizedLang = normalizeProjectLangSwitcherCode(lang);
                    SaveUserLang(normalizedLang);
                    setAppLang(normalizedLang);
                    i18n.changeLanguage(normalizedLang);
                }}
                key={'lang'}
                isProjectPage
                isCompetitionEdit={isCompetitionEdit}
            />
        )
    }, [i18n, isBilingual])

    return (
        <Wrapper>
            {AddButton}
            {isBilingual && i18n.language === 'en' && !isNewDafesSegment && <FlexBox direction='column' offsetTop={16}>
                <BilingualismItem>— AI does the translation</BilingualismItem>
                <BilingualismItem>— You can edit the AI translation</BilingualismItem>
                <BilingualismItem>— ​​Edited translation is considered author's translation</BilingualismItem>
                <BilingualismItem>— AI translation is updated automatically</BilingualismItem>
            </FlexBox>}
            {LangSwitcher}

        </Wrapper>
    )
}